import moment from 'moment';
import XLSX from 'sheetjs-style';
import { sToHMSColonSeparated } from '../../helpers';

const ApprovalTimecardExcel = (timesheetDetails) => {
  let ws = [];
  let user = '';
  const wb = XLSX.utils.book_new();
  const excelRows = [];
  let subHeading = '';
  const weeklyStatus = (status) => {
    switch (status) {
      case 'submit':
        return 'Submitted';
      case 'approve':
        return 'Approved';
      case 'reject':
        return 'Rejected';
      case 'withdraw':
        return 'Withdrawn';
      default:
        return 'Not Submitted';
    }
  };
  timesheetDetails.forEach((weekData) => {
    weekData.data.forEach((day) => {
      // For admin timesheet excel
      if (weekData.user) {
        subHeading = [
          'Team member',
          'Week Days',
          'Clock In',
          'Clock Out',
          'Breaks',
          'Total',
          'Status',
        ];
        user = {
          name: weekData.user.firstName,
          day: moment(day.date).format('ddd, MMM DD'),
          clockIn: day.clockIn ? moment(day.clockIn).format('hh:mm A') : '-',
          clockOut: day.clockOut ? moment(day.clockOut).format('hh:mm A') : '-',
          breakTime:
            day.totalBreakTimeSeconds > 0
              ? sToHMSColonSeparated(day.totalBreakTimeSeconds, 'hh:mm')
              : '00:00',

          Total:
            day.totalWorkSessionSeconds > 0
              ? sToHMSColonSeparated(day.totalWorkSessionSeconds, 'hh:mm')
              : '00:00',
          status: weeklyStatus(weekData.status),
        };
        // For teammember timesheet excel
      } else {
        subHeading = [
          'Week Days',
          'Clock In',
          'Clock Out',
          'Breaks',
          'Total',
          'Status',
        ];
        user = {
          day: moment(day.date).format('ddd, MMM DD'),
          clockIn: day.clockIn ? moment(day.clockIn).format('hh:mm A') : '-',
          clockOut: day.clockOut ? moment(day.clockOut).format('hh:mm A') : '-',
          breakTime:
            day.totalBreakTimeSeconds > 0
              ? sToHMSColonSeparated(day.totalBreakTimeSeconds, 'hh:mm')
              : '00:00',
          Total:
            day.totalWorkSessionSeconds > 0
              ? sToHMSColonSeparated(day.totalWorkSessionSeconds, 'hh:mm')
              : '00:00',
          status: weeklyStatus(weekData.status),
        };
      }
      excelRows.push(user);
    });
    ws = XLSX.utils.json_to_sheet(excelRows, {
      skipHeader: true,
      origin: 'A3',
    });

    const mainHeading = ['', '', '', 'Timecard ', '', '', ''];
    XLSX.utils.sheet_add_aoa(ws, [mainHeading, subHeading], {
      skipHeader: true,
      origin: 'A1',
    });

    // Adding style to extra column for admin
    if (weekData.user) {
      ws.G2.s = {
        font: { bold: true },
        alignment: { horizontal: 'center' },
        fill: {
          fgColor: { rgb: 'C9C0BB' },
        },
      };
    }
  });
  // Adding style to the cell
  ws.D1.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'e3c2bb' },
    },
  };

  ws.A2.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'C9C0BB' },
    },
  };
  ws.B2.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'C9C0BB' },
    },
  };
  ws.C2.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'C9C0BB' },
    },
  };
  ws.D2.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'C9C0BB' },
    },
  };
  ws.E2.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'C9C0BB' },
    },
  };
  ws.F2.s = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: {
      fgColor: { rgb: 'C9C0BB' },
    },
  };

  XLSX.utils.book_append_sheet(wb, ws, 'mySheet');
  XLSX.writeFile(wb, 'timesheet_report.xlsx');
};

export default ApprovalTimecardExcel;
